import React from "react";
import {Link} from 'react-router-dom';
import { lang } from "../../config/app.config";
interface MCprops{
  name:string,
  degisnation:string,
  image:any,
  sec?:boolean,
  id:number
}

const MemberCard:React.FC<MCprops> = props => {
  const {
    degisnation,
    image,
    name,
    sec,
    id
  } = props;

  return(
    <div className="ec-card">
        <p className={sec? "text-14-primary text-center mb-05":"text-20-primary text-center mb-05"}>{degisnation}</p>
        <div className={sec?"ec-card-img-sec":"ec-card-img"}>
          <Link to={`/${lang}/member/${id}`}>
            <img src={image} alt="" className={sec?"":"wh-105"}/>
          </Link>
        </div>
        <div className="ec-card-description">
          <Link to={`/${lang}/member/${id}`}>
           <h3 className={sec?"text-14-grey text-center":"text-16-grey text-center"} style={{color:'black',fontWeight:500}}>{name}</h3>
          </Link>
        </div>
      
    </div>
  );
}

export default MemberCard;